import React from "react";
import { Button, Typography, makeStyles, } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import HeroLayout from './HeroLayout';
import * as paths from "./../../Routes/paths"

const backgroundImage =
  'https://source.unsplash.com/HawVQHPWCjs/1400&x80';


const styles = makeStyles((theme) => ({
  background: {
	backgroundImage: `url(${backgroundImage})`,
	backgroundColor: '#b1c6ce', // Average color of the background image.
	backgroundPosition: 'center',
  },
  marked: {
    height: 4,
    width: 73,
    display: 'block',
    margin: `${theme.spacing(1)}px auto 0`,
    backgroundColor: theme.palette.secondary.main,
  },
  button: {
    minWidth: 200,
  },
  h5: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(10),
    },
  },
  more: {
    marginTop: theme.spacing(2),
  },
}));

const Hero = () => {
	const classes = styles();

    return(
	    <HeroLayout backgroundClassName={classes.background}>
	      {/* Increase the network loading priority of the background image. */}
	      <img style={{ display: 'none' }} src={backgroundImage} alt="increase priority" />
	      <Typography color="inherit" align="center" variant="h2">
	        Retailers asked for less hassle
	        <span className={classes.marked} />
	      </Typography>
	      <Typography color="inherit" align="center" variant="h5" className={classes.h5}>
	        Register with betastore and stock your store from your phone
	      </Typography>
	      <Button
	        color="secondary"
	        variant="contained"
	        size="large"
	        className={classes.button}
	        component={RouterLink}
	        to={paths.REGISTER}
	      >
	        Sign up
	      </Button>
	      <Typography variant="body2" color="inherit" className={classes.more}>
	        View all products
	      </Typography>
	    </HeroLayout>      
    )
}

export default Hero;
